import { groupBy } from '@/services/sanitize.service';
import db from '@/rxdb/database';

import { v4 as uuidv4 } from 'uuid';
import { combineLatest, firstValueFrom, map, mergeMap } from 'rxjs';

function mapCie(item) {
    if (item) {
        const plainItem = item.toMutableJSON();
        return {
            ...plainItem,
            emissionDueDate: plainItem.emissionDueDate ? new Date(plainItem.emissionDueDate) : null,
            emissionDate: plainItem.emissionDate ? new Date(plainItem.emissionDate) : null,
        };
    } else {
        return null;
    }
}

export async function bulkInsert(projectId, cie) {
    return db.getProjectCollections(projectId).cie.bulkInsert(cie);
}
function mapCies(dbCies) {
    const cies = dbCies.map(mapCie);
    return groupBy(cies, 'groupId').map((versions) => {
        versions.reverse();
        return {
            ...versions[0],
            versions,
        };
    });
}
function mergeToCie(cieId, dbCies) {
    const versions = dbCies.map(mapCie).reverse();
    const cie = versions.find((cie) => cie.id === cieId);
    return {
        ...cie,
        versions,
    };
}
export function getCIEs(projectId) {
    return db
        .getProjectCollections(projectId)
        .cie.find({ sort: [{ createdAt: 'asc' }] })
        .$.pipe(map(mapCies));
}

export function getCie(projectId, cieId) {
    return db
        .getProjectCollections(projectId)
        .cie.findOne({ selector: { id: cieId } })
        .$.pipe(
            mergeMap((cie) =>
                cie
                    ? combineLatest([
                          firstValueFrom(
                              db.getProjectCollections(projectId).cie.find({
                                  selector: { groupId: cie.groupId },
                                  sort: [{ createdAt: 'asc' }],
                              }).$,
                          ),
                      ])
                    : null,
            ),
        )
        .pipe(map(([cies]) => mergeToCie(cieId, cies)));
}

export function removeCie(projectId, id) {
    return db
        .getProjectCollections(projectId)
        .cie.findOne({ selector: { id: id } })
        .remove();
}

export async function createCie(projectId, item) {
    const result = await db.getProjectCollections(projectId).cie.insert({
        projectId,
        locationIds: [],
        groupId: uuidv4(),
        distribution: [],
        ...item,
        emissionDueDate: item.emissionDueDate ? item.emissionDueDate.toISOString() : null,
        emissionDate: item.emissionDate ? item.emissionDate.toISOString() : null,
    });
    return result.toJSON();
}

export async function updateCie(projectId, cie) {
    const dbCie = await db
        .getProjectCollections(projectId)
        .cie.findOne({ selector: { id: cie.id } })
        .exec();
    const patch = { ...JSON.parse(JSON.stringify(cie)) };
    if (cie.emissionDate === null || !!cie.emissionDate) {
        patch.emissionDate = cie.emissionDate ? cie.emissionDate.toISOString() : null;
    }
    if (cie.emissionDueDate === null || !!cie.emissionDueDate) {
        patch.emissionDueDate = cie.emissionDueDate ? cie.emissionDueDate.toISOString() : null;
    }
    return dbCie.atomicPatch(patch);
}

export async function removeCieGroup(projectId, cieGroupId) {
    const entities = await db
        .getProjectCollections(projectId)
        .cie.find({ selector: { groupId: cieGroupId } })
        .exec();
    return Promise.all(entities.map((entity) => entity.remove()));
}
